import type { ReactNode } from "react";

import { useSessionUser } from "@/hooks/useSessionUser";

type OwnerGateVariant = "default" | "hide";

type OwnerGateProps = {
  children: ReactNode;
  fallback?: ReactNode;
  variant?: OwnerGateVariant;
};

export function OwnerGate({ children, fallback = null, variant = "default" }: OwnerGateProps) {
  const { user } = useSessionUser();
  const normalizedUserType = user?.user_type?.toLowerCase() ?? "";
  const isOwner = Boolean(user?.is_owner || normalizedUserType === "owner");

  if (isOwner) {
    return <>{children}</>;
  }
  if (variant === "hide") {
    return null;
  }
  return <>{fallback}</>;
}

export default OwnerGate;
